/**
 * Copyright IBM Corp. 2022, 2026
 */

import Image from 'next/image'
import * as ProductLogos from 'lib/mktg-logos/all-product-logos_on-light'

export interface InlineLookupsProps {
	product?: string
}

function InlineLookups({ product }: InlineLookupsProps) {
	return (
		<Image {...ProductLogos[product]} alt={ProductLogos[product].alt || ''} />
	)
}

export default InlineLookups
